export const SUPERVISED_AREAS = ['ED', 'EH', 'LC', 'LH'];
